import axios from 'axios';

const WAVE_AUTH_CONFIG = {
  clientId: process.env.REACT_APP_WAVE_CLIENT_ID,
  clientSecret: process.env.REACT_APP_WAVE_CLIENT_SECRET,
  redirectUri: process.env.REACT_APP_WAVE_REDIRECT_URI,
  authUrl: 'https://api.waveapps.com/oauth2/authorize',
  tokenUrl: 'https://api.waveapps.com/oauth2/token',
  scope: 'account:read account:write business:read business:write invoice:read invoice:write'
};

class WaveAuthService {
  constructor() {
    this.accessToken = localStorage.getItem('wave_access_token');
    this.refreshToken = localStorage.getItem('wave_refresh_token');
  }

  // Initialize OAuth flow
  initiateAuth() {
    const params = new URLSearchParams({
      client_id: WAVE_AUTH_CONFIG.clientId,
      redirect_uri: WAVE_AUTH_CONFIG.redirectUri,
      response_type: 'code',
      scope: WAVE_AUTH_CONFIG.scope
    });

    // Instead of directly redirecting, return the URL
    return `${WAVE_AUTH_CONFIG.authUrl}?${params.toString()}`;
  }

  // Handle OAuth callback
  async handleCallback(code) {
    try {
      console.log('Handling callback with code:', code);

      const response = await axios.post('https://monday-wave-app.goldquestor.workers.dev', {
        code
      });

      console.log('Token response:', response.data);

      if (response.data.error) {
        throw new Error(response.data.error_description || 'Failed to get access token');
      }

      if (response.data.access_token) {
        this.setTokens(response.data.access_token, response.data.refresh_token);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Token exchange error:', error);
      throw new Error(error.response?.data?.error_description || error.message);
    }
  }

  // Refresh access token
  async refreshAccessToken() {
    try {
      const response = await axios.post(WAVE_AUTH_CONFIG.tokenUrl, {
        grant_type: 'refresh_token',
        refresh_token: this.refreshToken,
        client_id: WAVE_AUTH_CONFIG.clientId,
        client_secret: WAVE_AUTH_CONFIG.clientSecret
      });

      this.setTokens(response.data);
      return response.data;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  }

  // Store tokens
  setTokens(accessToken, refreshToken) {
    this.accessToken = accessToken;
    localStorage.setItem('wave_access_token', accessToken);
    if (refreshToken) {
      this.refreshToken = refreshToken;
      localStorage.setItem('wave_refresh_token', refreshToken);
    }
  }

  // Clear tokens
  logout() {
    this.accessToken = null;
    this.refreshToken = null;
    localStorage.removeItem('wave_access_token');
    localStorage.removeItem('wave_refresh_token');
  }

  // Check if user is authenticated
  isAuthenticated() {
    const token = localStorage.getItem('wave_access_token');
    return !!token;
  }

  // Get access token
  getAccessToken() {
    return this.accessToken;
  }
}

export default new WaveAuthService(); 